export const stateCountries = [
    {
        v: 'AU',
        states: [
            { v: 'ACT', n: 'Australian Capital Territory' },
            { v: 'NSW', n: 'New South Wales' },
            { v: 'NT', n: 'Northern Territories' },
            { v: 'QLD', n: 'Queensland' },
            { v: 'SA', n: 'South Australia' },
            { v: 'TAS', n: 'Tasmania' },
            { v: 'VIC', n: 'Victoria' },
            { v: 'WA', n: 'Western Australia' },
        ],
    },
    {
        v: 'CA',
        states: [
            { v: 'AB', n: 'Alberta' },
            { v: 'BC', n: 'British Columbia' },
            { v: 'MB', n: 'Manitoba' },
            { v: 'NB', n: 'New Brunswick' },
            { v: 'NL', n: 'Newfoundland and Labrador' },
            { v: 'NS', n: 'Nova Scotia' },
            { v: 'NT', n: 'Northwest Territories' },
            { v: 'NU', n: 'Nunavut' },
            { v: 'ON', n: 'Ontario' },
            { v: 'PE', n: 'Prince Edward Island' },
            { v: 'QC', n: 'Quebec' },
            { v: 'SK', n: 'Saskatchewan' },
            { v: 'YT', n: 'Yukon Territory' },
        ],
    },
    {
        v: 'US',
        states: [
            { v: 'AA', n: 'Armed Forces Americas' },
            { v: 'AE', n: 'Armed Forces Europe/Middle East/Canada' },
            { v: 'AK', n: 'Alaska' },
            { v: 'AL', n: 'Alabama' },
            { v: 'AP', n: 'Armed Forces Pacific' },
            { v: 'AR', n: 'Arkansas' },
            { v: 'AS', n: 'American Samoa' },
            { v: 'AZ', n: 'Arizona' },
            { v: 'CA', n: 'California' },
            { v: 'CO', n: 'Colorado' },
            { v: 'CT', n: 'Connecticut' },
            { v: 'DC', n: 'District of Columbia' },
            { v: 'DE', n: 'Delaware' },
            { v: 'FL', n: 'Florida' },
            { v: 'FM', n: 'Federated States of Micronesia' },
            { v: 'GA', n: 'Georgia' },
            { v: 'GU', n: 'Guam' },
            { v: 'HI', n: 'Hawaii' },
            { v: 'IA', n: 'Iowa' },
            { v: 'ID', n: 'Idaho' },
            { v: 'IL', n: 'Illinois' },
            { v: 'IN', n: 'Indiana' },
            { v: 'KS', n: 'Kansas' },
            { v: 'KY', n: 'Kentucky' },
            { v: 'LA', n: 'Louisiana' },
            { v: 'MA', n: 'Massachusetts' },
            { v: 'MD', n: 'Maryland' },
            { v: 'ME', n: 'Maine' },
            { v: 'MH', n: 'Marshall Islands' },
            { v: 'MI', n: 'Michigan' },
            { v: 'MN', n: 'Minnesota' },
            { v: 'MO', n: 'Missouri' },
            { v: 'MP', n: 'Northern Mariana Islands' },
            { v: 'MS', n: 'Mississippi' },
            { v: 'MT', n: 'Montana' },
            { v: 'NC', n: 'North Carolina' },
            { v: 'ND', n: 'North Dakota' },
            { v: 'NE', n: 'Nebraska' },
            { v: 'NH', n: 'New Hampshire' },
            { v: 'NJ', n: 'New Jersey' },
            { v: 'NM', n: 'New Mexico' },
            { v: 'NV', n: 'Nevada' },
            { v: 'NY', n: 'New York' },
            { v: 'OH', n: 'Ohio' },
            { v: 'OK', n: 'Oklahoma' },
            { v: 'OR', n: 'Oregon' },
            { v: 'PA', n: 'Pennsylvania' },
            { v: 'PR', n: 'Puerto Rico' },
            { v: 'PW', n: 'Palau' },
            { v: 'RI', n: 'Rhode Island' },
            { v: 'SC', n: 'South Carolina' },
            { v: 'SD', n: 'South Dakota' },
            { v: 'TN', n: 'Tennessee' },
            { v: 'TT', n: 'Trust Territories' },
            { v: 'TX', n: 'Texas' },
            { v: 'UT', n: 'Utah' },
            { v: 'VA', n: 'Virginia' },
            { v: 'VI', n: 'Virgin Islands' },
            { v: 'VT', n: 'Vermont' },
            { v: 'WA', n: 'Washington' },
            { v: 'WI', n: 'Wisconsin' },
            { v: 'WV', n: 'West Virginia' },
            { v: 'WY', n: 'Wyoming' },
        ],
    },
]

export const months = [
    { name: 'Jan', value: '01' },
    { name: 'Feb', value: '02' },
    { name: 'Mar', value: '03' },
    { name: 'Apr', value: '04' },
    { name: 'May', value: '05' },
    { name: 'Jun', value: '06' },
    { name: 'Jul', value: '07' },
    { name: 'Aug', value: '08' },
    { name: 'Sep', value: '09' },
    { name: 'Oct', value: '10' },
    { name: 'Nov', value: '11' },
    { name: 'Dec', value: '12' },
]
export const years = (() => {
    let currYear = new Date().getFullYear()
    let yearArray = []
    for (let i = 0; i < 20; i++) {
        let _nextYear = currYear + i
        yearArray.push({
            name: _nextYear,
            value: _nextYear.toString().substr(-2),
        })
    }

    return yearArray
})();

export const zones = [
    {
        country: "HK",
        states: [
            { stateCode: "IS", stateDesc: "Hong Kong Island" },
            { stateCode: "KN", stateDesc: "Kowloon" },
            { stateCode: "NT", stateDesc: "New Territories" }
        ]
    }
];
export const districts = [
    {
        country: "HK",
        states: [
            { stateCode: "Aberdeen", stateDesc: "Aberdeen" },
            { stateCode: "Admiralty", stateDesc: "Admiralty" },
            { stateCode: "Ap Lei Chau", stateDesc: "Ap Lei Chau" },
            { stateCode: "Causeway Bay", stateDesc: "Causeway Bay" },
            { stateCode: "Central", stateDesc: "Central" },
            { stateCode: "Chai Wan", stateDesc: "Chai Wan" },
            { stateCode: "Cheung Sha Wan", stateDesc: "Cheung Sha Wan" },
            { stateCode: "Choi Hung", stateDesc: "Choi Hung" },
            { stateCode: "Deep Water Bay", stateDesc: "Deep Water Bay" },
            { stateCode: "Diamond Hill", stateDesc: "Diamond Hill" },
            { stateCode: "Fanling", stateDesc: "Fanling" },
            { stateCode: "Fo Tan", stateDesc: "Fo Tan" },
            { stateCode: "Happy Valley", stateDesc: "Happy Valley" },
            { stateCode: "Ho Man Tin", stateDesc: "Ho Man Tin" },
            { stateCode: "Hung Hom", stateDesc: "Hung Hom" },
            { stateCode: "Hung Shui Kiu", stateDesc: "Hung Shui Kiu" },
            { stateCode: "Jardine's Lookout", stateDesc: "Jardine's Lookout" },
            { stateCode: "Kennedy Town", stateDesc: "Kennedy Town" },
            { stateCode: "Kowloon Bay", stateDesc: "Kowloon Bay" },
            { stateCode: "Kowloon City", stateDesc: "Kowloon City" },
            { stateCode: "Kowloon Tong", stateDesc: "Kowloon Tong" },
            { stateCode: "Kwai Chung", stateDesc: "Kwai Chung" },
            { stateCode: "Kwun Tong", stateDesc: "Kwun Tong" },
            { stateCode: "Lai Chi Kok", stateDesc: "Lai Chi Kok" },
            { stateCode: "Lam Tei", stateDesc: "Lam Tei" },
            { stateCode: "Lam Tin", stateDesc: "Lam Tin" },
            { stateCode: "Lamma Island", stateDesc: "Lamma Island" },
            { stateCode: "Lantau Island", stateDesc: "Lantau Island" },
            { stateCode: "Lo Wu", stateDesc: "Lo Wu" },
            { stateCode: "Ma On Shan", stateDesc: "Ma On Shan" },
            { stateCode: "Ma Wan", stateDesc: "Ma Wan" },
            { stateCode: "Mid-Levels", stateDesc: "Mid-Levels" },
            { stateCode: "Mongkok", stateDesc: "Mongkok" },
            { stateCode: "Ngau Chi Wan", stateDesc: "Ngau Chi Wan" },
            { stateCode: "Ngau Tau Kok", stateDesc: "Ngau Tau Kok" },
            { stateCode: "North Point", stateDesc: "North Point" },
            { stateCode: "Pat Heung", stateDesc: "Pat Heung" },
            { stateCode: "Pok Fu Lam", stateDesc: "Pok Fu Lam" },
            { stateCode: "Quarry Bay", stateDesc: "Quarry Bay" },
            { stateCode: "Repulse Bay", stateDesc: "Repulse Bay" },
            { stateCode: "Sai Kung", stateDesc: "Sai Kung" },
            { stateCode: "Sai Wan", stateDesc: "Sai Wan" },
            { stateCode: "Sai Wan Ho", stateDesc: "Sai Wan Ho" },
            { stateCode: "San Po Kong", stateDesc: "San Po Kong" },
            { stateCode: "San Tin", stateDesc: "San Tin" },
            { stateCode: "Sau Mau Ping", stateDesc: "Sau Mau Ping" },
            { stateCode: "Sha Tau Kok", stateDesc: "Sha Tau Kok" },
            { stateCode: "Shatin", stateDesc: "Shatin" },
            { stateCode: "Sham Shui Po", stateDesc: "Sham Shui Po" },
            { stateCode: "Sham Tseng", stateDesc: "Sham Tseng" },
            { stateCode: "Shau Kei Wan", stateDesc: "Shau Kei Wan" },
            { stateCode: "Shek Kip Mei", stateDesc: "Shek Kip Mei" },
            { stateCode: "Shek O", stateDesc: "Shek O" },
            { stateCode: "Sheung Shui", stateDesc: "Sheung Shui" },
            { stateCode: "Sheung Wan", stateDesc: "Sheung Wan" },
            { stateCode: "Siu Sai Wan", stateDesc: "Siu Sai Wan" },
            { stateCode: "Stanley", stateDesc: "Stanley" },
            { stateCode: "Ta Kwu Ling", stateDesc: "Ta Kwu Ling" },
            { stateCode: "Tai Kok Tsui", stateDesc: "Tai Kok Tsui" },
            { stateCode: "Tai Lam Chung", stateDesc: "Tai Lam Chung" },
            { stateCode: "Tai Po", stateDesc: "Tai Po" },
            { stateCode: "Tai Wai", stateDesc: "Tai Wai" },
            { stateCode: "Taikoo Shing", stateDesc: "Taikoo Shing" },
            { stateCode: "Tai Tam", stateDesc: "Tai Tam" },
            { stateCode: "Tin Shui Wai", stateDesc: "Tin Shui Wai" },
            { stateCode: "Ting Kok", stateDesc: "Ting Kok" },
            { stateCode: "Tiu Keng Leng", stateDesc: "Tiu Keng Leng" },
            { stateCode: "The Peak", stateDesc: "The Peak" },
            { stateCode: "To Kwa Wan", stateDesc: "To Kwa Wan" },
            { stateCode: "Tseung Kwan O", stateDesc: "Tseung Kwan O" },
            { stateCode: "Tsim Sha Tsui", stateDesc: "Tsim Sha Tsui" },
            { stateCode: "Tsing Yi", stateDesc: "Tsing Yi" },
            { stateCode: "Tsuen Wan", stateDesc: "Tsuen Wan" },
            { stateCode: "Tsz Wan Shan", stateDesc: "Tsz Wan Shan" },
            { stateCode: "Tuen Mun", stateDesc: "Tuen Mun" },
            { stateCode: "Tung Chung", stateDesc: "Tung Chung" },
            { stateCode: "Wan Chai", stateDesc: "Wan Chai" },
            { stateCode: "Wong Chuk Hang", stateDesc: "Wong Chuk Hang" },
            { stateCode: "Wong Tai Sin", stateDesc: "Wong Tai Sin" },
            { stateCode: "Yau Ma Tei", stateDesc: "Yau Ma Tei" },
            { stateCode: "Yau Tong", stateDesc: "Yau Tong" },
            { stateCode: "Yuen Long", stateDesc: "Yuen Long" }
        ]
    }
];
